import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as FileSaver from "file-saver";
import { EnumManagerReportNotes } from "../../../../shared/enums/enumManagerReportNotes";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { ManagerReportNotesComponent } from "../manager-report-notes/manager-report-notes.component";
import { Q3SecondGridReportLocationWiseBcReportDto } from "../../../../core/models/dashboard-poc/q3SecondGridReportLocationWiseBcReportDto";

@Component({
  selector: "jni-location-wise-q3-grid2",
  templateUrl: "./location-wise-q3-grid2.component.html",
  styleUrls: ["./location-wise-q3-grid2.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DialogModule,
    ManagerReportNotesComponent,
  ],
})
export class LocationWiseQ3Grid2Component {
  @Input() grid2: Q3SecondGridReportLocationWiseBcReportDto[] = [];
  @Input() location = "";
  @Input() manager = "";
  @Input() isSuperManager = false;
  @Input() isAdmin = false;
  @Input() currentQuarter = "";
  @Output() submitEvent = new EventEmitter<{
    manager: string;
    bcPersonnelNumber: string;
    notes: string;
    type: string;
  }>();
  fileName = "dashboard-poc";

  managerNotesModal = false;
  bcPersonnelNumber = "";
  notes = "";

  bcReportEnum = EnumManagerReportNotes[EnumManagerReportNotes.BcReport];

  exportExcelFile() {
    const object = this.grid2.map(datum => {
      return {
        ["Support Name"]: datum.bc,
        ["Title"]: datum.title,
        ["Actual Support %"]: datum.supportBasedOffNumber,
        ["Notes"]: datum.notes,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(
        excelBuffer,
        `${this.location} - ${this.currentQuarter} Report`
      );
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  // onNotesClick(data: any) {
  //   if (this.isSuperManager || this.isAdmin) {
  //     this.managerNotesModal = true;
  //     this.bcPersonnelNumber = data.bcPersonnelNumber;
  //     this.notes = data.notes;
  //     this.bcPersonnelNumber = data.bcPersonnelNumber;
  //   }
  // }

  onCancel() {
    this.managerNotesModal = false;
  }

  onSubmit(data: {
    manager: string;
    bcPersonnelNumber: string;
    notes: string;
    type: string;
  }) {
    this.managerNotesModal = false;
    this.submitEvent.emit(data);
  }
}
